@if (visible) {
  <div class="modal_customer">
    @if (selectionVisible) {
      <div class="modal_customer_body">
        <div class="modal_text_md text-center">Verify your identity</div>
        <br>
          <div class="modal_text_sm text-center">
            You have exceeded the maximum number<br>
            of attempts to enter verification code. <br>
            Select a different way to receive a new<br>
            code.
          </div>
          <br>
            @if (isSMS === true) {
              <button class="button button-default"
                style="width: 290px;"
              (click)="newMobile()">New Mobile Number</button>
            }
            @if (isSMS === false) {
              <button class="button button-default"
                style="width: 290px;"
              (click)="newMobile()">Mobile Number</button>
            }
            @if (isSMS === true) {
              <button class="button button-default"
                style="width: 290px;"
              (click)="newEmail()">E-mail Address</button>
            }
            @if (isSMS === false) {
              <button class="button button-default"
                style="width: 290px;"
              (click)="newEmail()">New E-mail Address</button>
            }
            <br>
            </div>
          }
          @if (mobileVisible) {
            <div class="modal_customer_body">
              <div class="modal_text_md text-center">Verify your identity</div>
              <br>
                <div class="modal_text_sm text-center">
                  Please enter your mobile number to
                  <br>receive a new OTP.
                  </div>
                  <br>
                    <form [formGroup]="form">
                      <label [ngClass]="{'label-error': this.form.controls['mobile'].invalid && this.form.controls['mobile'].touched  }">
                        Mobile Number
                        <input type="text"
                          [ngClass]="{'input-error': this.form.controls['mobile'].invalid && this.form.controls['mobile'].touched  }"
                          maxlength="13"
                          formControlName="mobile"
                          class="form-control"
                          placeholder="+63">
                        </label>
                      </form>
                      <br>
                        <button class="button button-active"
                          [disabled]="this.form.controls['mobile'].invalid"
                          (click)="retryMobile()"
                        style="width: 290px;">Send Code</button>
                        <br>
                        </div>
                      }
                      @if (emailVisible) {
                        <div class="modal_customer_body">
                          <div class="modal_text_md text-center">Verify your identity</div>
                          <br>
                            <div class="modal_text_sm text-center">
                              Please enter your email address to receive <br>a new OTP.
                            </div>
                            <br>
                              <form  [formGroup]="form">
                                <label [ngClass]="{'label-error': this.form.controls['email'].invalid && this.form.controls['email'].touched  }">
                                  E-mail Address
                                  <input type="text"
                                    formControlName="email"
                                    class="form-control"
                                    [ngClass]="{'input-error': this.form.controls['email'].invalid && this.form.controls['email'].touched  }"
                                    maxlength="255"
                                    placeholder="">
                                  </label>
                                </form>
                                <br>
                                  <button class="button button-active"
                                    [disabled]="this.form.controls['email'].invalid"
                                    (click)="retryEmail()"
                                  style="width: 290px;">Send Code</button>
                                  <button class="button button-default"
                                    style="width: 290px;"
                                  (click)="cancel()">Cancel</button>
                                  <br>
                                  </div>
                                }
                              </div>
                            }
